<template>
  <div class="json-mapper">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">json mapper</div>
      <div v-if="!isLoading">
        <div>
          <div
            class="json-mapper-content-wrapper fancy-scroll"
            @scroll.passive="showScrollbar"
          >
            <div>
              <jsonMapperComponent
                ref="jsonMapperComponent"
                :task="task"
                :objectValues="objectValues"
                :flowRunnerEndpoint="flowRunnerEndpoint"
                @onRemoveObjectElement="onRemoveObjectElement"
                :isUserHasAccess="isUserHasAccess"
              />
            </div>
          </div>

          <div class="add-button-wrapper" v-if="isUserHasAccess">
            <PlusIconButton @onClick="onAddNewObjectElement" />
          </div>
        </div>
      </div>
      <div class="loading-container" v-if="isLoading">
        <LoadingSpinner
          loadingCaption="Wird gespeichert..."
          v-show="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import jsonMapperComponent from '../widgets/jsonMapperComponent.vue';
import { getMapJson } from '../../services/workflow.service';
import { debouncer } from '../../utils/helpers';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import PlusIconButton from '../widgets/PlusIconButton.vue';

export default {
  data() {
    return {
      isLoading: false,
      objectValues: [],
    };
  },
  props: {
    task: {
      type: Object,
    },
    isUserHasAccess: {
      type: Boolean,
      required: false,
      default: true,
    },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  mounted() {
    if (this.task.props) {
      this.objectValues = Object.keys(this.task.props).map((key, index) => ({
        id: parseInt(Date.now().toString() + index),
        key,
        value: this.task.props[key],
        keyError: false,
        valueError: false,
      }));
    }
  },

  methods: {
    async close() {
      try {
        this.isLoading = true;
        this.onSaveObjectValue();
        const isInvalidInput = this.objectValues.some(
          (objectElement) => objectElement.keyError || objectElement.valueError
        );

        if (isInvalidInput) return;
        this.task.props = this.getObjectFromArrayOfObjects();
        const generatedJson = await this.getJSONMapperOutput();
        this.$set(
          this.task,
          'output',
          this.task.input.concat([
            {
              name: 'mappedjson',
              label: 'mapped json',
              type: 'json',
              value: generatedJson.data,
            },
          ])
        );
        this.$emit('close');
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    onAddNewObjectElement() {
      this.objectValues.push({
        id: Date.now(),
        key: null,
        value: null,
        keyError: false,
        valueError: false,
      });
    },
    onRemoveObjectElement(index) {
      this.objectValues.splice(index, 1);
    },

    getObjectFromArrayOfObjects() {
      return this.objectValues.reduce((acc, { key, value }) => {
        if (key && value) {
          acc[key] = value;
        }
        return acc;
      }, {});
    },
    async getJSONMapperOutput() {
      try {
        const generatedJSON = await getMapJson(
          {
            inputJson: JSON.stringify(this.task.input),
            props: JSON.stringify(this.task.props),
          },
          this.flowRunnerEndpoint
        );

        return generatedJSON;
      } catch (error) {
        //
      }
    },

    onSaveObjectValue() {
      this.objectValues.forEach((obj) => {
        obj.keyError = false;
        obj.valueError = false;

        obj.keyError =
          (obj.key &&
            (!this.$refs.jsonMapperComponent.isValidInput(obj.key) ||
              this.$refs.jsonMapperComponent
                .getAllKeyNames(obj.id)
                .includes(obj.key))) ||
          (!obj.key && obj.value)
            ? true
            : false;

        obj.valueError =
          (obj.value &&
            !this.$refs.jsonMapperComponent.isValidInput(obj.value)) ||
          (obj.key && !obj.value)
            ? true
            : false;
      });
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
  },

  components: {
    jsonMapperComponent,
    LoadingSpinner,
    PlusIconButton,
  },
};
</script>

<style scoped>
.json-mapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.json-mapper .btn-close {
  position: relative;
  z-index: 9;
  top: 10px;
  right: 5px;
  padding: 10px 10px;
}

.json-mapper .add-button-wrapper {
  width: fit-content;
  margin: 40px auto 0px auto;
}

.json-mapper .json-mapper-content-wrapper {
  min-height: 200px;
  margin-top: 36px;
  max-height: calc(60vh - 36px);
  overflow-y: scroll;
}

.json-mapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
</style>
